import { cn } from '../../lib/cn';
import styles from './Card.module.css';

export function Card({
  as: Tag = 'div',
  tone,        // 'alt' | 'dark'
  elevation,   // 'raised' | 'float'
  bordered = false,
  radius,      // 'sm'
  flush = false,
  hoverable = false,
  className,
  children,
  ...rest
}) {
  return (
    <Tag
      className={cn(
        styles.card,
        bordered && styles.bordered,
        elevation && styles[elevation],
        tone && styles[tone],
        radius && styles[radius],
        flush && styles.flush,
        hoverable && styles.hoverable,
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}
